function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { i18n, PermissionService, SessionSelectors } from 'invision-core';
import LocaleKeys from '../../../locales/keys';
import { CouponRedemptionCodeErrorSelector } from '../../../reducers/selectors/coupon.redemption.code.selectors';
import { CustomerCouponsErrorSelector } from '../../../reducers/selectors/customer.coupons.selectors';
import { COUPON_REDEMPTION_CODE_UPDATE_ACCESS, COUPON_REDEMPTION_CODE_VIEW_ACCESS } from '../../../security.attributes';
var RESEND_REDEMPTION_CODE_ID = 'RESEND_REDEMPTION_CODE_ID';
var REMOVE_REDEMPTION_CODE_ID = 'REMOVE_REDEMPTION_CODE_ID';
var RedemptionCodeDetailsHeaderController = /*#__PURE__*/function () {
  function RedemptionCodeDetailsHeaderController($ngRedux, $timeout, $q) {
    _classCallCheck(this, RedemptionCodeDetailsHeaderController);
    this.$ngRedux = $ngRedux;
    this.$timeout = $timeout;
    this.$q = $q;
  }
  return _createClass(RedemptionCodeDetailsHeaderController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.CustomerLocaleKeys = LocaleKeys;
      this.resendRedemptionCodePopupConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this.resendRedemptionCodePopupApi = api;
        }
      };
      this.resendRedemptionCodeErrorPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this.resendRedemptionCodeErrorPopupApi = event.api;
        }
      };
      this.removeRedemptionCodePopupConfig = {
        onRegisterApi: function onRegisterApi(_ref2) {
          var api = _ref2.api;
          _this.removeRedemptionCodePopupApi = api;
        }
      };
      this.removeRedemptionCodeErrorPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this.removeRedemptionCodeErrorPopupApi = event.api;
        }
      };
      this.mapStateToTarget = function (store) {
        return {
          customerCouponsError: CustomerCouponsErrorSelector(store),
          lastAttemptError: CouponRedemptionCodeErrorSelector(store),
          userSecurityAttributes: SessionSelectors.UserSecurityAttributesSelector(store)
        };
      };
      this.controllerActions = {};
      this.disconnectRedux = this.$ngRedux.connect(this.mapStateToTarget, this.controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.moreMenuOptions = this.buildMoreOptionsMenu();
    }
  }, {
    key: "$onChanges",
    value: function $onChanges() {
      if (this.state) {
        this.moreMenuOptions = this.buildMoreOptionsMenu();
      }
    }
  }, {
    key: "buildMoreOptionsMenu",
    value: function buildMoreOptionsMenu() {
      var moreOptionsMenu = [];
      if (this.redemptionCodeDetails.isFetching) {
        return moreOptionsMenu;
      }
      if (this.canResend) {
        moreOptionsMenu.push({
          id: RESEND_REDEMPTION_CODE_ID,
          title: i18n.translate(LocaleKeys.COUPONS.REDEMPTION_CODE_DETAILS.MORE_OPTIONS.RESEND_REDEMPTION_CODE)
        });
      }
      if (this.canRemove) {
        moreOptionsMenu.push({
          id: REMOVE_REDEMPTION_CODE_ID,
          title: i18n.translate(LocaleKeys.COUPONS.REDEMPTION_CODE_DETAILS.MORE_OPTIONS.REMOVE_REDEMPTION_CODE)
        });
      }
      return moreOptionsMenu;
    }
  }, {
    key: "openResendRedemptionCodePopup",
    value: function openResendRedemptionCodePopup() {
      this.showResendRedemptionCodePopup = true;
      this.$timeout(this.resendRedemptionCodePopupApi.open);
    }
  }, {
    key: "closeResendRedemptionCodePopup",
    value: function closeResendRedemptionCodePopup(redemptionCodeResent, error) {
      this.showResendRedemptionCodePopup = false;
      this.resendRedemptionCodePopupApi.close();
      if (error) {
        this.resendRedemptionCodeErrorPopupApi.open();
      }
    }
  }, {
    key: "closeResendRedemptionCodeModalErrorPopup",
    value: function closeResendRedemptionCodeModalErrorPopup() {
      this.resendRedemptionCodeErrorPopupApi.close();
    }
  }, {
    key: "openRemoveRedemptionCodePopup",
    value: function openRemoveRedemptionCodePopup() {
      this.showRemoveRedemptionCodePopup = true;
      this.$timeout(this.removeRedemptionCodePopupApi.open);
    }
  }, {
    key: "closeRemoveRedemptionCodePopup",
    value: function closeRemoveRedemptionCodePopup(paymentMethodUpdated, error) {
      this.showRemoveRedemptionCodePopup = false;
      this.removeRedemptionCodePopupApi.close();
      if (error) {
        this.removeRedemptionCodeErrorPopupApi.open();
      }
    }
  }, {
    key: "closeRemoveRedemptionCodeModalErrorPopup",
    value: function closeRemoveRedemptionCodeModalErrorPopup() {
      this.removeRedemptionCodeErrorPopupApi.close();
    }
  }, {
    key: "handleMoreOptionsMenuSelected",
    value: function handleMoreOptionsMenuSelected(option) {
      switch (option.item.id) {
        case RESEND_REDEMPTION_CODE_ID:
          this.openResendRedemptionCodePopup();
          break;
        case REMOVE_REDEMPTION_CODE_ID:
          this.openRemoveRedemptionCodePopup();
          break;
        default:
          break;
      }
    }
  }, {
    key: "canRemove",
    get: function get() {
      return this.userHasUpdatePermissions && !this.hasBeenRemoved;
    }
  }, {
    key: "hasBeenRemoved",
    get: function get() {
      return this.redemptionCodeDetails.RedemptionCode.Status === 2;
    }
  }, {
    key: "canResend",
    get: function get() {
      return this.userHasViewPermissions && this.redemptionCodeDetails.RedemptionCode.IsRedeemable && this.redemptionCodeDetails.RedemptionCode.SubscriberId;
    }
  }, {
    key: "userHasUpdatePermissions",
    get: function get() {
      return PermissionService.hasAccess(this.state.userSecurityAttributes, COUPON_REDEMPTION_CODE_UPDATE_ACCESS);
    }
  }, {
    key: "userHasViewPermissions",
    get: function get() {
      return PermissionService.hasAccess(this.state.userSecurityAttributes, COUPON_REDEMPTION_CODE_VIEW_ACCESS);
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  bindings: {
    redemptionCodeDetails: '<',
    returnUiSref: '@'
  },
  template: require('./redemption.code.details.header.html'),
  controller: RedemptionCodeDetailsHeaderController
};